/**
 * DriftGraph component module.
 * @module shared/components/DriftGraph
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import Pie from '../../../../shared/components/graphs/Pie';
import {_openModal} from '../../../../shared/reducers/modals';
import {connect} from 'react-redux';
import useSWR from 'swr';
import {_getConfig} from '../../../../shared/reducers/config';
import history from '../../../../history';
import useQueryObject from '../../../../shared/utils/useQueryObject';
import {LoadingSpinner} from '../../../../shared';
import Row from '../../../../shared/components/Row';
import {buildQueryContext} from '../../../../shared/utils/utils';

const DriftGraph = ({containerID, config, getConfig}) => {
  const [context] = useQueryObject('context');
  React.useEffect(() => {
    getConfig();
  }, []);

  const {data} = useSWR(containerID && `/containers/${containerID}`);
  const formattedData = React.useMemo(() => data?.counts && config && config.models
    && (data.counts.accounts.total
      ? [
        {name: 'On Target', color: config.models.driftStatuses['On Target'].color, y: data.counts.accounts.onTarget},
        {name: 'Drifted', color: config.models.driftStatuses.Drifted.color, y: data.counts.accounts.drifted},
        {
          name: 'Recent Request',
          color: config.models.driftStatuses['Recent Request'].color,
          y: data.counts.accounts.recentRequest,
        },
        {
          name: 'Recent Proposal',
          color: config.models.driftStatuses['Recent Proposal'].color,
          y: data.counts.accounts.recentProposal,
        },
        {name: 'No Model', color: config.models.driftStatuses['No Model'].color, y: data.counts.accounts.noModel},
        {
          name: 'Not Applicable',
          color: config.models.driftStatuses['Not Applicable'].color,
          y: data.counts.accounts.notApplicable,
        },
        {name: 'Data Issues', color: config.models.driftStatuses['Data Issues'].color, y: data.counts.accounts.dataIssues},
      ]
      : [{name: 'No Rebalancing Proposals', color: config.models.driftStatuses['Not Applicable'].color, y: 1}]), [data, config]);

  if (!formattedData) {
    return <LoadingSpinner/>;
  }
  return <Row height={'100px'}
              alignSubRow={'stretch'}
              alignItems={'stretch'}
              layout={{grow: 1}}>
    <Pie data={formattedData}
         sliceAction={slice => history.push(`/analyze/containers/${containerID}/accounts?${buildQueryContext(
           context,
           {balancingAlert: slice.name}
         )}`)}
         centerAction={() => history.push(`/analyze/containers/${containerID}/accounts?${buildQueryContext(
           context,
           {dataSet: formattedData}
         )}`)}
    />
  </Row>;
};

const mapStateToProps = state => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  getConfig: force => dispatch(_getConfig(force)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DriftGraph);

DriftGraph.propTypes = {
  config: PropTypes.object,
  openModal: PropTypes.func,
  getConfig: PropTypes.func,
  containerID: PropTypes.number.isRequired,
};
